import createReactClass from 'create-react-class'

var React = require('react')
var moment = require('moment')
var _ = require('lodash')

var cx = require('classnames')

const locale = {
    weekLabel: 'W',
    monthNames: moment.monthsShort(),
    firstDay: 0
}

function buildCalendar(m) {
    var firstDay = moment(m).startOf('month')
    var lastMonth = moment(firstDay)
        .subtract(1, 'day')
        .month()
    var lastYear = moment(firstDay)
        .subtract(1, 'day')
        .year()
    var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth()
    var dayOfWeek = firstDay.day()
    var calendar = []

    for (var i = 0; i < 6; i++) calendar[i] = []

    var startDay = daysInLastMonth - dayOfWeek + locale.firstDay + 1
    if (startDay > daysInLastMonth) startDay -= 7

    if (dayOfWeek == locale.firstDay) startDay = daysInLastMonth - 6

    var curDate = moment([lastYear, lastMonth, startDay, 12])

    for (
        var i = 0, col = 0, row = 0;
        i < 42;
        i++,
            col++,
            curDate = moment(curDate)
                .add(24, 'hours')
                .hours(12)
    ) {
        if (i > 0 && col % 7 == 0) {
            col = 0
            row++
        }
        calendar[row][col] = curDate.clone()
    }

    return calendar
}

var Day = createReactClass({
    render: function() {
        var props = this.props
        var calendar = props.calendar
        var selected = props.selected
        var start = props.start
        var end = props.end
        var startOfDay = moment(start).startOf('day')
        var endOfDay = moment(end).endOf('day')
        var min = moment(props.min).isValid ? moment(props.min).startOf('day') : null
        var max = moment(props.max).isValid ? moment(props.max).endOf('day') : null
        var onSelect = props.onSelect
        var onMouseEnterDate = props.onMouseEnterDate
        var onMouseLeaveDate = props.onMouseLeaveDate
        var showCalendar = props.showCalendar
        var row = props.row
        var col = props.col

        var m = calendar[row][col]
        var curr = m.format('YYYY-MM-DD')
        var day = m.date()

        var isDisabled = (min && m < min) || (max && m > max)
        
        var cls = cx({
            off: isDisabled,
            disabled: isDisabled,
            'in-range': m >= startOfDay && m <= endOfDay,
            active: curr == selected.format('YYYY-MM-DD'),
            'start-date': curr == start.format('YYYY-MM-DD'),
            'end-date': curr == end.format('YYYY-MM-DD'),
            available: true
        })

        function onClick() {
            if (isDisabled) return
            typeof onSelect == 'function' && onSelect(+m)
        }

        function onMouseEnter() {
            if (isDisabled) return
            typeof onMouseEnterDate == 'function' && onMouseEnterDate(+m)
        }

        function onMouseLeave() {
            if (isDisabled) return
            typeof onMouseLeaveDate == 'function' && onMouseLeaveDate(+m)
        }

        if (showCalendar) {
            return (
                <td className={cls} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                    <span>
                        <span> {day} </span>
                    </span>
                </td>
            )
        } else {
            return (
                <td className={cls} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                    {day}
                </td>
            )
        }
    }
})

var Week = createReactClass({
    render: function() {
        var props = this.props
        var calendar = props.calendar
        var selected = props.selected
        var start = props.start
        var end = props.end
        var min = props.min
        var max = props.max
        var onSelect = props.onSelect
        var onMouseEnterDate = props.onMouseEnterDate
        var onMouseLeaveDate = props.onMouseLeaveDate
        var showCalendar = props.showCalendar

        var row = this.props.row
        var cols = []

        for (var col = 0; col < 7; col++) {
            cols.push(
                <Day
                    key={col}
                    row={row}
                    col={col}
                    calendar={calendar}
                    selected={selected}
                    start={start}
                    end={end}
                    min={min}
                    max={max}
                    onSelect={onSelect}
                    onMouseEnterDate={onMouseEnterDate}
                    onMouseLeaveDate={onMouseLeaveDate}
                    showCalendar={showCalendar}
                />
            )
        }

        return <tr>{cols}</tr>
    }
})

var Header = createReactClass({
    render: function() {
        var props = this.props
        var calendar = props.calendar
        var daysOfWeek = []

        _.each(moment.weekdaysMin(), function(d, i) {
            daysOfWeek.push(<th key={i}>{d}</th>)
        })

        var prevCls = cx({
            prev: true,
            available: true
        })
        var nextCls = cx({
            next: true,
            available: true
        })

        return (
            <thead>
                <tr>
                    <th className={prevCls} onClick={this.props.onPrevMonth}>
                        &lt;
                        <i />
                    </th>
                    <th colSpan="5">
                        {this.props.fullMonth ? calendar[1][1].format('MMMM YYYY') : calendar[1][1].format('MMM YYYY')}
                    </th>
                    <th className={nextCls} onClick={this.props.onNextMonth}>
                        &gt;
                        <i />
                    </th>
                </tr>
                <tr>{daysOfWeek}</tr>
            </thead>
        )
    }
})

function myState(current) {
    return {
        current: current,
        calendar: buildCalendar(current)
    }
}

var Month = createReactClass({
    getInitialState: function() {
        return myState(moment(this.props.timestamp))
    },
    render: function() {
        var calendar = this.state.calendar
        var props = this.props
        var selected = moment(props.timestamp)
        var start = moment(props.start)
        var end = moment(props.end)
        var min = props.min ? moment(props.min) : null
        var max = props.max ? moment(props.max) : null
        var onSelect = props.onSelect
        var onMouseEnterDate = props.onMouseEnterDate
        var onMouseLeaveDate = props.onMouseLeaveDate
        var fullMonth = props.fullMonth
        var showCalendar = props.showCalendar

        var weeks = []

        for (var i = 0; i < 6; i++) {
            weeks.push(
                <Week
                    key={i}
                    row={i}
                    calendar={calendar}
                    selected={selected}
                    start={start}
                    end={end}
                    min={min}
                    max={max}
                    onSelect={onSelect}
                    onMouseEnterDate={onMouseEnterDate}
                    onMouseLeaveDate={onMouseLeaveDate}
                    showCalendar={showCalendar}
                />
            )
        }

        return (
            <div className="calendar-date">
                <table>
                    <Header
                        calendar={calendar}
                        fullMonth={fullMonth}
                        onPrevMonth={this.onPrevMonth}
                        onNextMonth={this.onNextMonth}
                    />
                    <tbody>{weeks}</tbody>
                </table>
            </div>
        )
    },
    onPrevMonth: function() {
        this.state.current.subtract(1, 'month')
        this.setState(myState(this.state.current))
    },
    onNextMonth: function() {
        this.state.current.add(1, 'month')
        this.setState(myState(this.state.current))
    }
})

// module.exports = Month
export default Month
